
<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>{{this.translate.data['ADDUSER'] | translate}}</h4>        
    </div>
    <div class="card-body">
        <form [formGroup]="userForm" novalidate>
            
            <div class="row">
                <!-- <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input type="text" matInput placeholder="{{this.translate.data['USERNAME'] | translate}}" formControlName="userName" required>
                        <mat-error *ngIf="!userForm.controls['userName'].valid && userForm.controls['userName'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                    </mat-form-field>
                </div> -->
                <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="Email" formControlName="email" required>
                        <mat-error *ngIf="!userForm.controls['email'].valid && userForm.controls['email'].touched"> {{
                            getErrorEmail() }} </mat-error>
                    </mat-form-field>
                </div>

                <!-- <div class="col-md-4">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['PHONENUMBER'] | translate}}" formControlName="phoneNumber" required>
                        <mat-error *ngIf="!userForm.controls['phoneNumber'].valid && userForm.controls['phoneNumber'].touched"> {{
                            getErrorEmail() }} </mat-error>
                    </mat-form-field>
                </div> -->
            </div>            

            <!-- <div class="row">                
                <div class="col-md-6">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['FIRSTNAME'] | translate}}" formControlName="firstName" required>
                        <mat-error *ngIf="!userForm.controls['firstName'].valid && userForm.controls['firstName'].touched">{{this.translate.data['ERRORALERT'] | translate}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field class="example-full-width">
                        <input matInput placeholder="{{this.translate.data['LASTNAME'] | translate}}" formControlName="lastName" required>
                        <mat-error *ngIf="!userForm.controls['lastName'].valid && userForm.controls['lastName'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                    </mat-form-field>
                </div>                
            </div>    -->
            
            <!-- <div class="row">
                <div class="col-md-4">
                    <section class="example-full-width">
                        <mat-slide-toggle color="primary" formControlName="emailConfirmed" labelPosition="before">{{this.translate.data['EMAILCONFIRMED'] | translate}}
                        </mat-slide-toggle>
                    </section>
                </div>
                <div class="col-md-4">
                    <section class="example-full-width">
                        <mat-slide-toggle color="primary" formControlName="phonenumberConfirmed" labelPosition="before">{{this.translate.data['PHONENUMBERCONFIRMED'] | translate}}</mat-slide-toggle>
                    </section>
                </div>
                <div class="col-md-4">
                    <section class="example-full-width">
                        <mat-slide-toggle color="primary" formControlName="twoFactorEnabled" labelPosition="before">{{this.translate.data['TWOFACTORENABLED'] | translate}}</mat-slide-toggle>
                    </section>
                </div>
            </div>            -->

            <!-- <div class="row" *ngIf="admin"> -->
            <!-- <div class="row" *ngIf="admin">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <mat-select placeholder="Select a Tenant" formControlName="tenant"  multiple>
                            <mat-option *ngFor="let item of tenants" [value]="item">
                                {{item.displayName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div> -->

            <div class="row">
                <div class="col-md-12">
                    <mat-form-field appearance="fill" >
                        <mat-label>{{this.translate.data['SELECTUSERROLE'] | translate}}</mat-label>
                        <mat-select formControlName="userRoles" multiple>
                            <mat-option *ngFor="let role of groupRoles" [value]="role">
                                {{role.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="!userForm.controls['userRoles'].valid && userForm.controls['userRoles'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <!-- <button matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" mat-button (click)="cancel()" >
                    <mat-icon>close</mat-icon>
                </button>
                <span style="flex: 1 1 auto"></span>
                <button matTooltip="{{this.translate.data['TOOLTIPADDUSERDIALOG'] | translate}}" mat-button (click)="add()">
                    <mat-icon>add</mat-icon>
                </button> -->
                <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
                                    (click)="cancel()" >Abbruch</button>
                </a>                                                
                <span style="flex: 1 1 auto"></span>
                <a>
                        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="{{this.translate.data['TOOLTIPADDUSERDIALOG'] | translate}}"
                                        (click)="add()" >Hinzufügen</button>
                </a>                   
    
            </div>    
        </form>
    </div>
</div>

